export const VOYAGE_HEADER = "Voyage";
export const EVENT_OPTIONS = [
	{
		label: "ARRIVAL",
		value: "ARRIVAL",
	},
	{
		label: "DEPARTURE",
		value: "DEPARTURE",
	},
	{
		label: "NOON",
		value: "NOON",
	},
	{
		label: "STS-OPL",
		value: "STS-OPL",
	},
];
